import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './libs/http'
import platform from 'platform'

import MuseUI from 'muse-ui'
import Message from 'muse-ui-message'
import Toast from 'muse-ui-toast'
import { NoticeBar } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import 'muse-ui/dist/muse-ui.css'
import 'muse-ui-message/dist/muse-ui-message.css'
import 'font-awesome/css/font-awesome.min.css'
import 'vant/lib/notice-bar/style'

if (platform.name.toLocaleLowerCase().indexOf('ie') >= 0) {
    document.getElementById('sysalert').style.display = 'block'
} else {
    Vue.config.productionTip = false
    Vue.prototype.$http = http
    // Vue.prototype.$message = Message

    Vue.use(MuseUI)
    Vue.use(Message)
    Vue.use(Toast)
    Vue.use(NoticeBar)
    Vue.use(Swipe)
    Vue.use(SwipeItem)

    new Vue({
        router,
        beforeMount() {
            let self = document.getElementById('bootSpinner')
            self.parentElement.removeChild(self)
        },
        render: h => h(App)
    }).$mount('#app')
}
